import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';
import {PRODUCT_TYPE} from "../lib/constants";
import app from "./app";

let cartObject = {
    order: '', // order hash code
    products: [],
    total_weight: 0,
    total_products: 0,
    shipping_price: 0,
    total_price: 0,
    region_id: 0,
    updated: false,
    show: false,
};

const {get, set, update, subscribe} = writable(cartObject);

const cart = {
    set,
    update,
    subscribe,

    initialize: () => {
        cart.update(obj => {
            obj.products = [];
            let coo = cookie.get('hva-cart') || null;
            if (coo && coo != 'undefined') {
                let value = JSON.parse(coo);
                if (value.products) {
                    obj.products = value.products;
                }
                if (value.region_id) {
                    obj.region_id = value.region_id;
                }
                if (value.order) {
                    obj.order = value.order;
                }
            }

            cart.calculateTotals();
            return obj;
        });
    },

    toggle: (state) => {
        cart.update(obj => {
            obj.show = state;
            return obj;
        });
    },

    setProducts: products => {
        cart.update(obj => {
            let cartProducts = [];
            products.map(item => {
                let product = obj.products.find(x => x.id == item.id);
                if (product) {
                    product.type = ~~item.type;
                    product.name = item.name;
                    product.image = item.image;
                    product.weight = item.weight ? ~~item.weight : 0;
                    product.price = parseFloat(item.price);
                    product.quantity = ~~product.quantity || 1;
                    product.requires_account = ~~item.requires_account;
                    product.requires_subscription = ~~item.requires_subscription;

                    cartProducts = [...cartProducts, product];
                }
            });
            obj.products = cartProducts;

            cart.saveCookie();
            cart.calculateTotals();

            return obj;
        });
    },

    addToCart: (product, quantity = null) => {
        cart.update(obj => {
            if (quantity != null) {
                product.quantity = quantity;
            } else {
                product.quantity = product.min_quantity ? product.min_quantity : 1;
            }

            let item = cartObject.products.find(x => x.id == product.id);
            if (item) {
                item.type = ~~product.type;
                item.name = product.name;
                item.no_vat = product.no_vat;
                item.weight = product.weight ? ~~product.weight : 0;
                item.price = parseFloat(product.price);
                item.image = product.image;
                item.quantity = ~~product.quantity;
            } else {
                obj.products = [...obj.products, {
                    id: product.id,
                    type: ~~product.type,
                    name: product.name,
                    no_vat: product.no_vat,
                    weight: product.weight ? ~~product.weight : 0,
                    price: parseFloat(product.price),
                    image: product.image,
                    quantity: ~~product.quantity,
                    requires_account: product.requires_account,
                    requires_subscription: product.requires_subscription,
                }];
            }

            cart.saveCookie();
            cart.calculateTotals();

            return obj;
        });
    },

    removeFromCart: id => {
        cart.update(obj => {
            obj.products = obj.products.filter(x => x.id != id);

            cart.saveCookie();
            cart.calculateTotals();

            return obj;
        });
    },

    clear: () => {
        cart.update(obj => {
            obj.order = '';
            obj.products = [];
            cookie.delete('hva-cart');
            cart.calculateTotals();

            return obj;
        });
    },

    saveCookie: () => {
        let value = {
            // products: cartObject.products.map(item => (item.id)),
            order: cartObject.order,
            products: cartObject.products,
            region_id: cartObject.region_id
        }
        // let coo = JSON.stringify(cartObject.products);
        let coo = JSON.stringify(value);
        cookie.create('hva-cart', coo);
    },

    calculateTotals: () => {
        cart.update(obj => {
            obj.total_weight = 0;
            obj.shipping_price = 0;
            obj.total_price = 0;
            obj.total_products = 0;

            obj.products.map(item => {
                item.total_price = item.price * item.quantity;
                obj.total_weight += item.weight * item.quantity;
                obj.total_products += item.quantity;
                obj.total_price += item.total_price;
            });

            if (obj.total_weight > 0 && obj.region_id > 0) {
                let region = app.getRegion(obj.region_id);
                if (region) {
                    let shipping = app.getShipping(region.shipping_id);

                    if (shipping) {
                        shipping.extra_weight = ~~shipping.extra_weight;
                        shipping.extra_price = parseFloat(shipping.extra_price);
                        shipping.max_price = parseFloat(shipping.max_price);

                        let maxWeight = 0;
                        let maxPrice = 0;
                        let shippingPrice = 0;

                        // init shipping prices
                        // find maximum weight and price
                        shipping.prices.map(item => {
                            item.min_weight = ~~item.min_weight;
                            item.max_weight = ~~item.max_weight;
                            item.price = parseFloat(item.price);
                            if (maxWeight < item.max_weight) {
                                maxWeight = item.max_weight;
                                maxPrice = item.price;
                            }
                        });

                        if (obj.total_weight > maxWeight) {
                            let restWeight = obj.total_weight - maxWeight;
                            let multiplier = Math.ceil(restWeight / shipping.extra_weight);
                            shippingPrice = maxPrice +  (multiplier * shipping.extra_price);
                        } else {
                            shipping.prices.map(item => {
                                if (obj.total_weight >= item.min_weight && obj.total_weight <= item.max_weight) {
                                    shippingPrice = item.price;
                                }
                            });
                        }

                        // set maximum shipping price if any
                        if (shipping.max_price > 0 && shippingPrice > shipping.max_price) {
                            shippingPrice = shipping.max_price;
                        }

                        obj.shipping_price = shippingPrice;
                    }
                }
            }

            // set updated to true so Checkout component
            // will display the updated
            obj.updated = true;

            return obj;
        });
    },

    requiresAddress: () => {
        return cartObject.products.filter(x => x.type == PRODUCT_TYPE.PRODUCT).length > 0;
    },

    getProductIds: () => {
        return cartObject.products.map(item => item.id);
    }
}

export default cart;